// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__1GiEo"};